import { createSelector } from 'reselect';
export var feedSelector = function feedSelector(state) {
  return state.feed;
};
var notificationSettingsSelector = createSelector(feedSelector, function (feed) {
  return feed.notificationSettings;
});
var eventSelector = createSelector(feedSelector, function (feed) {
  return feed.event;
});
export var notificationSelector = createSelector(eventSelector, notificationSettingsSelector, function (event, notificationSettings) {
  var eventsToNotify = notificationSettings.events.filter(function (ev) {
    return ev.notify === true;
  }).map(function (ev) {
    return ev.type;
  });
  if (event != null && eventsToNotify.indexOf(event.type) > -1) {
    return event;
  }
});